var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "no-user",
    viewBox: "0 0 43 55",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 2,
    width: 6,
    height: 69,
    rx: 3,
    ry: 3,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7925 27.0321C31.9739 28.0832 31.1049 28.9641 30.1981 29.7067C35.349 32.8269 38.8074 38.5399 38.8074 45.0581C38.8074 47.2603 35.7678 48.725 33.9553 49.4024C30.6736 50.6289 26.0271 51.3331 21.2104 51.3331C16.3936 51.3331 11.7472 50.6302 8.46541 49.4024C6.65299 48.725 3.61337 47.2603 3.61337 45.0581C3.61337 38.5399 7.07173 32.8257 12.2227 29.7067C11.3171 28.9641 10.4468 28.082 9.62829 27.0321C3.83409 30.8808 -0.00012207 37.5233 -0.00012207 45.0594C-0.00012207 47.3807 1.2523 50.6148 7.21551 52.8439C10.9362 54.2344 15.9055 55 21.2091 55C26.5127 55 31.482 54.2344 35.2027 52.8439C41.1672 50.6148 42.4184 47.3807 42.4184 45.0594C42.4184 37.5233 38.5841 30.8808 32.7925 27.0321Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.209 29.1433C27.8937 29.1433 33.0408 22.5841 33.0408 14.829C33.0408 7.07391 27.8937 0.514679 21.209 0.514679C14.5256 0.514679 9.3772 7.07263 9.3772 14.829C9.3772 22.5854 14.5256 29.1433 21.209 29.1433ZM21.209 4.17904C25.742 4.17904 29.4286 8.95603 29.4286 14.8277C29.4286 20.6994 25.7407 25.4764 21.209 25.4764C16.6773 25.4764 12.9894 20.6994 12.9894 14.8277C12.9894 8.95603 16.6773 4.17904 21.209 4.17904Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/no-user.27bf8d7845aee766bf342ed1039d7b6c.svg";
export { ForwardRef as ReactComponent };